import React from 'react';
import { BrandIcon } from '../../ui/common';
import type { BrandType } from '../../ui/common/BrandIcon';
import type { ViewMode } from '../../domain/types';

export type BottomNavTab = Extract<ViewMode, 'radar' | 'jira' | 'slack' | 'github' | 'wiki'>;

interface MobileBottomNavProps {
  activeView: ViewMode;
  isDrawerOpen: boolean;
  onSelectView: (view: BottomNavTab) => void;
}

const TABS: Array<{
  id: BottomNavTab;
  label: string;
  brand: BrandType;
  testId: string;
  /** Appended to the label for the accessible name, e.g. ", Jira". Omitted
   * for tabs (Radar, Knowledge Wiki) that aren't backed by an external
   * provider — their own label is already the full name. */
  providerLabel?: string;
}> = [
  { id: 'radar', label: 'Radar', brand: 'radar', testId: 'radar' },
  { id: 'jira', label: 'Tareas', brand: 'jira', testId: 'tasks', providerLabel: 'Jira' },
  { id: 'slack', label: 'Mensajes', brand: 'slack', testId: 'messages', providerLabel: 'Slack' },
  { id: 'github', label: 'Código', brand: 'github', testId: 'code', providerLabel: 'GitHub' },
  { id: 'wiki', label: 'Wiki', brand: 'wiki', testId: 'wiki' },
];

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  activeView,
  isDrawerOpen,
  onSelectView,
}) => {
  const primaryActive = TABS.some((tab) => tab.id === activeView)
    ? (activeView as BottomNavTab)
    : null;

  return (
    <nav className="z-bottom-nav" data-testid="mobile-bottom-nav" aria-label="Navegación principal">
      {TABS.map((tab) => {
        const active = !isDrawerOpen && primaryActive === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className="z-bottom-nav__btn"
            data-active={active ? 'true' : 'false'}
            data-testid={`mobile-nav-${tab.testId}`}
            aria-label={tab.providerLabel ? `${tab.label}, ${tab.providerLabel}` : tab.label}
            aria-current={active ? 'page' : undefined}
            onClick={() => onSelectView(tab.id)}
          >
            <BrandIcon source={tab.brand} size={18} />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
